export default __webpack_public_path__ + "static/media/1.261c390b.png";